import React, {useState} from "react";
import {Box, Select, Text} from "grommet";

const SelectTeamMember = ({
    value, onChange, teamMembers, customerId,currentlySelectedId, ...rest
}) => {
    const [selectedTeamMember, setSelectedTeamMember] = useState(currentlySelectedId || '');
    return (
        <Select
            placeholder="Select team member"
            value={selectedTeamMember}
            options={teamMembers}
            onChange={(event) => {
                setSelectedTeamMember(event.value);
                if (onChange) { onChange(event); }
            }}
            labelKey={(obj) => `${obj.first_name} ${obj.last_name} (${obj.email})`}
            valueKey={{ key: 'id', reduce: true }}
            dropHeight="medium"
            {...rest}
        >
            {(option, index) => (
                <Box gap="xxsmall" key={index} pad="xsmall">
                    <Text weight="bold">
                        {`${option.first_name} ${option.last_name}`}
                    </Text>
                    <Text size="xsmall" color="text-weak" weight="bold">
                        {option.email}
                    </Text>
                </Box>
            )}
        </Select>
    );
};

export default SelectTeamMember;
